<template>
  <div class="ma-4 px-4">
    <searchBar :addField="false" @updateSearch="(v) => (search = v)" />

    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="FeeRequestHeaders"
            :search="search"
            :items="items"
            :custom-filter="customFilter"
            fixed-header
            class="secondary row-height-50"
          >
            <template v-slot:[`item.action`]="{ item }">
              <v-icon
                class="mr-2"
                color="accent"
                @click="navigateToFeeRequests(item)"
              >
                mdi-dots-horizontal
              </v-icon>
            </template>

            <template #[`item.partner_id`]="{ item }">
              {{ getPartnerName(item.partner_id) }}
            </template>
            <template #[`item.program_id`]="{ item }">
              {{ getProgramName(item.program_id) }}
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import searchBar from "@/components/searchBar.vue";
import { FeeRequestHeaders } from "@/constants/headers";

export default {
  components: {
    searchBar,
  },
  data() {
    return {
      items: [],
      search: "",
      FeeRequestHeaders,
      partners: [],
      programs: [],
    };
  },
  created() {
    this.$store.commit("setBreadcrumbs", [{ text: "Term Invoice" }]);
    this.initialise();
  },
  methods: {
    initialise() {
      this.getPartners();
      this.getPrograms();
      this.getFeeRequests();
    },

    async getPartners() {
      await this.$axios.get("/partners").then((res) => {
        this.partners = res.data.data;
      });
    },

    async getPrograms() {
      await this.$axios.get("/programs").then((res) => {
        this.programs = res.data.data;
      });
    },

    getPartnerName(id) {
      const partner = this.partners.find((p) => p.id == id);
      return partner ? partner.name : "";
    },

    getProgramName(id) {
      const program = this.programs.find((p) => p.id === id);
      return program
        ? program.degree.short_name +
            (program.specialization ? " - " + program.specialization : "")
        : "";
    },
    async getFeeRequests() {
      await this.$axios
        .get("/get_term_fee_request")
        .then((res) => {
          this.items = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response?.data?.message || "Failed to fetch",
            color: "error",
          });
        });
    },
    navigateToFeeRequests(item) {
      this.$router.push({
        path: "/term-fee-request-year-batch",
        query: {
          partner_id: item.partner_id,
          program_id: item.program_id,
        },
      });
    },
    customFilter(value, search, item) {
      if (!search) return true;

      const programName = this.getProgramName(item.program_id);
      const partnerName = this.getPartnerName(item.partner_id);

      return (
        JSON.stringify(item).toLowerCase().includes(search.toLowerCase()) ||
        programName.toLowerCase().includes(search.toLowerCase()) ||
        partnerName.toLowerCase().includes(search.toLowerCase())
      );
    },
  },
};
</script>

<style></style>
